import type { Auth } from "firebase/auth";
import { signOut } from "firebase/auth";
import { clearGxlAuthCookie } from "./cookie";
import { deleteServerSession } from "./serverSession";

/**
 * Clear the shared server session, sign out Firebase, then redirect.
 *
 * Server logout and getIdToken are best-effort. A deleted or already-invalid
 * account must still be able to clear local Firebase state and leave the app.
 */
export async function unauthenticateUser(
  auth: Auth | null,
  redirectTo: string = "/login",
  idTokenOverride?: string,
  serverSessionAlreadyCleared = false,
): Promise<void> {
  if (!serverSessionAlreadyCleared) {
    let idToken = idTokenOverride;
    if (!idToken) {
      try {
        idToken = await auth?.currentUser?.getIdToken();
      } catch (error) {
        console.debug("[Auth] Could not read ID token during logout:", error);
      }
    }
    await deleteServerSession(idToken);
  }
  clearGxlAuthCookie();
  if (auth) {
    try {
      await signOut(auth);
    } catch (error) {
      console.debug("[Auth] Firebase sign-out failed:", error);
    }
  }
  window.location.href = redirectTo;
}
